import { useEffect, useState } from "react";

const API_BASE = (
  process.env.REACT_APP_GOOURHUB_BUSINESS_API ||
  "https://business-api.goourhub.com"
).replace(/\/+$/, "");

export default function useManagedCommunities() {
  const [communities, setCommunities] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const controller = new AbortController();

    const load = async () => {
      try {
        setError("");

        const response = await fetch(
          `${API_BASE}/api/config/communities`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
            signal: controller.signal,
          }
        );

        const data = await response
          .json()
          .catch(() => ({}));

        if (!response.ok || data?.success === false) {
          throw new Error(
            data?.message ||
              `Unable to load communities (${response.status}).`
          );
        }

        const items = Array.isArray(data?.communities)
          ? data.communities
          : [];

        if (!controller.signal.aborted) {
          setCommunities(items);
          setLoaded(true);
        }
      } catch (err) {
        if (
          err?.name !== "AbortError" &&
          !controller.signal.aborted
        ) {
          console.error(
            "Unable to load managed communities.",
            err
          );

          setError(
            err?.message ||
              "Managed communities could not be loaded."
          );

          setLoaded(false);
        }
      }
    };

    load();

    return () => controller.abort();
  }, []);

  return {
    communities,
    loaded,
    error,
  };
}